import { useEffect, useState } from "react";
import { Paperclip, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";

const CATEGORIE = [
  ["entrata", "Documenti in Entrata"], ["uscita", "Documenti in Uscita"], ["avvocato", "Allegati Avvocato"],
  ["perito", "Allegati Perito"], ["cessionario", "Allegati Cessionario"], ["fornitore", "Allegati Fornitore"], ["assistito", "Allegati Assistito"],
];
const sel = "w-full h-9 rounded-md border border-slate-700 bg-slate-900 px-2 text-sm text-slate-100";

export const MailAttToPraticaDialog = ({ msg, account, onClose, only = null }) => {
  const [checked, setChecked] = useState([]);
  const [soggetti, setSoggetti] = useState([]);
  const [akey, setAkey] = useState("principale");
  const [cat, setCat] = useState("entrata");
  const [busy, setBusy] = useState(false);
  const atts = msg?.attachments || [];

  useEffect(() => {
    if (!msg) return;
    setChecked(only !== null ? [only] : atts.map((_, i) => i)); setCat("entrata"); setAkey("principale");
    api.get(`/studio/pratiche/${msg.pratica_id}/soggetti`).then(({ data }) => {
      const cl = data.filter((s) => s.tipo === "cliente");
      setSoggetti(cl);
      const match = cl.find((s) => s.nome && (msg.soggetto || "").toLowerCase().includes(s.nome.toLowerCase()));
      if (match) setAkey(match.assistito_key); else if (cl[0]) setAkey(cl[0].assistito_key);
    }).catch(() => setSoggetti([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msg, only]);

  const toggle = (i) => setChecked((c) => (c.includes(i) ? c.filter((x) => x !== i) : [...c, i]));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/studio/mail/${msg.account || account}/messages/${msg.id}/attachments-to-pratica`,
        { indexes: checked, assistito_key: akey, categoria: cat });
      toast.success(`${data.saved.length} allegat${data.saved.length === 1 ? "o salvato" : "i salvati"} nella pratica ${msg.pratica_numero}`);
      onClose();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={!!msg} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-lg" data-testid="mail-att-to-pratica-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Paperclip className="h-4 w-4 text-amber-400" /> Salva negli allegati della pratica{msg?.pratica_numero ? ` ${msg.pratica_numero}` : ""}</DialogTitle>
          <DialogDescription className="text-slate-400">Scegli i file, il cliente e la sezione degli Allegati in cui salvarli.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5 max-h-52 overflow-y-auto">
            {atts.map((a, i) => (only !== null && i !== only) ? null : (
              <label key={i} className="flex items-center gap-2 text-sm bg-slate-900/50 rounded px-3 py-1.5 cursor-pointer" data-testid={`mail-att-pick-${i}`}>
                <input type="checkbox" checked={checked.includes(i)} onChange={() => toggle(i)} className="accent-amber-500" />
                <span className="truncate">{a.nome}</span>
              </label>
            ))}
          </div>
          {soggetti.length > 1 && (
            <div><div className="text-xs text-slate-400 mb-1">Cliente</div>
              <select value={akey} onChange={(e) => setAkey(e.target.value)} className={sel} data-testid="mail-att-soggetto">
                {soggetti.map((s) => <option key={s.key} value={s.assistito_key}>{s.nome}</option>)}
              </select></div>
          )}
          <div><div className="text-xs text-slate-400 mb-1">Sezione</div>
            <select value={cat} onChange={(e) => setCat(e.target.value)} className={sel} data-testid="mail-att-categoria">
              {CATEGORIE.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select></div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} className="border-slate-700" data-testid="mail-att-cancel">Annulla</Button>
          <Button onClick={save} disabled={busy || !checked.length} data-testid="mail-att-save" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
